import { NgModule } from '@angular/core';

import { ClientReachBottomMenuComponent } from './components/bottom-menu/bottom-menu.component';
import { ClientMenuClearButtonComponent } from './components/menu-clear-button/menu-clear-button.component';
import {
	ClientReachMenuComponent,
	ClientReachMenuSectionDirective,
} from './main/main-menu.directive';

export { ClientReachMenuComponent } from './main/main-menu.directive';
export { openMenuWithResult } from './utils/open-menu-with-result';

@NgModule({
	imports: [
		ClientReachMenuComponent,
		ClientReachMenuSectionDirective,
		ClientMenuClearButtonComponent,
		ClientReachBottomMenuComponent,
	],
	exports: [
		ClientReachMenuComponent,
		ClientReachMenuSectionDirective,
		ClientMenuClearButtonComponent,
		ClientReachBottomMenuComponent,
	],
})
export class ClientReachMenuModule {}
